import React from 'react';
import classNames from 'classnames/bind';
import { useSelector, useDispatch } from 'react-redux';
import useMountEffect from '@restart/hooks/useMountEffect';

import { getRuntimeUsers } from '../constants/runtimeConfig';
import styles from './index.module.scss';
import actions from '../actions';
import Form from './Form';
import Menu from './Menu';

const cx = classNames.bind(styles);

const Page = () => {
  const dispatch = useDispatch();
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);

  useMountEffect(() => {
    const userInfo = JSON.parse(localStorage.getItem('@ims/isLoggedInfo'));
    const configuredUsers = Object.values(getRuntimeUsers());

    if (userInfo) {
      const { role, menus, key, tmsUserRid } = userInfo;
      const matchedUser = configuredUsers.find((user) => user.info?.role === role && user.key === key);

      if (matchedUser) {
        dispatch(
          actions.auth.login(
            matchedUser.id,
            role,
            menus,
            key,
            matchedUser.tmsUserRid ?? tmsUserRid ?? null,
          ),
        );
        return;
      }

      localStorage.removeItem('@ims/isLoggedInfo');
      dispatch(actions.auth.logout());
    } else {
      dispatch(actions.auth.logout());
    }
  });

  return (
    <div className={cx('container')}>
      {isLoggedIn === false && <Form />}
      {isLoggedIn === true && <Menu />}
    </div>
  );
};

export default Page;
